export default "__VITE_ASSET__DiuUv4B7__"